import { useDeviceType } from '@cian/ui-kit';
import { Welcome } from 'shared/components/Welcome';

export const WelcomeContainer: React.FC = () => {
  const device = useDeviceType();

  return <Welcome device={device} />;
};
